import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Input, Label } from "reactstrap";

import FeatherIcon from "feather-icons-react";
// payment_systems

import paymentSystems from "../../assets/images/payment_systems.png"

class Footer extends Component {
  phone1 = "";
  sended = false;
  constructor(props) {
    super(props);
    this.state = {
      grid1: [
        { title: "Главная", link: "/" },
        { title: "Техническим специалистам", link: "/it" },
        { title: "Решения кафе и ресторанам", link: "/restaurant" },
        { title: "Политика конфиденциальности", link: "/privacyPolicy" },
        { title: "Правила безопасной оплаты", link: "/ruleSecurePayment" },
      ],
    };
  }

  phoneChanged(e) {
    this.phone1 = e.target.value;
  }

  sendPhone(phone) {
    if (phone != "") {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phone, from: "soft.kit-app.ru", comment: "Нижняя форма, обратный звонок" })
      };
      fetch("/api/v1/sendFeedback/", requestOptions)
        .then((result)=> {
          console.log(result);
          this.setState({
            sended: true,
          });
        });
    }
  }

  render() {
    return (
      <React.Fragment>
        <footer className={this.props.isLight ? "footer bg-light" : "footer"}>
          <Container>
            <Row>
              <Col lg="4" xs="12" className="mb-0 mb-md-4 pb-0 pb-md-2" name="footercolumn">
                <Link to="/" className="logo-footer">
                  KitApp <span class="text-primary fw-bold">@Soft</span>
                </Link>
                <p className={this.props.isLight ? "mt-4 text-muted" : "mt-4"}>
                  ИП Алёшин<br />
                  г. Тюмень, 50 лет ВЛКСМ, 79, 37<br />
                  ИНН: 720322249890<br />
                  <a href="tel:+74955681372"><i className="mdi mdi-phone text-info"></i> +7(495)568-13-72</a><br />
                  <a href="mailto:it@kit-app.ru"><i className="mdi mdi-email text-info"></i> it@kit-app.ru</a>
                </p>
              </Col>

              <Col lg="5" md="8" xs="12" className="mt-4 mt-sm-0 pt-2 pt-sm-0" name="footercolumn">
                <h5 className={ this.props.isLight ? "text-dark footer-head" : "text-light footer-head" }>
                  Ссылки
                </h5>
                <ul className="list-unstyled footer-list mt-4">
                  {this.state.grid1.map((grid, key) => (
                    <li key={key}>
                      <a href={grid.link} className={ this.props.isLight ? "text-muted" : "text-foot" }>
                        <i className="mdi mdi-chevron-right me-1"></i>{" "}
                        {grid.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </Col>

              <Col lg="3" md="4" xs="12" className="mt-4 mt-sm-0 pt-2 pt-sm-0" name="footercolumn">
                <h5 className={ this.props.isLight ? "text-dark footer-head" : "text-light footer-head" }>
                  Обратный звонок
                </h5>
                <p className="mt-4">
                  Оставьте свой телефон, мы обязательно с вами свяжемся.
                </p>
                {/* <Form> */}
                  <Row>
                    <Col lg="12">
                      <div className={ this.props.isLight ? "foot-subscribe mb-3 foot-white" : "foot-subscribe mb-3" }>
                        <Label className={this.props.isLight ? "form-label text-muted" : "form-label"}>
                          Введите номер{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <div className="form-icon position-relative">
                          <FeatherIcon icon="phone" className="fea icon-sm icons"/>
                        </div>
                        <Input 
                          type="phone" 
                          name="phone" 
                          id="emailsubscribe" 
                          className={ 
                            false
                              ? "ps-5 rounded bg-light border" 
                              : "ps-5 rounded" 
                          }
                          style={{"color":"black"}}
                          placeholder="Ваш телефон : "
                          required
                          onKeyUp={(e)=>{this.phoneChanged(e);}}
                        />
                      </div>
                    </Col>
                    <Col lg="12">
                      <div className="d-grid">
                        { this.state.sended ? ("Отправлено, мы с Вам скоро свяжемся!") : (
                          <button class="btn btn-pills btn-primary" onClick={()=>{this.sendPhone(this.phone1)}}>Отправить</button>
                        ) }
                      </div>
                    </Col>
                  </Row>
                {/* </Form> */}
              </Col>
            </Row>
          </Container>
        </footer>
        <footer className="footer footer-bar">
          <Container className="text-center">
            <Row className="align-items-center">
            <Col sm="6">
                <div className="text-sm-start">
                  <p className="mb-0">
                    © 2021. Разработано с{" "}
                    <i className="mdi mdi-heart text-danger"></i>{" "}.
                    
                    {/* <a href="/" target="_blank" rel="noopener noreferrer" className="text-reset">
                      KitApp
                    </a>. */}
                  </p>
                </div>
              </Col>
              <Col sm="6">
                <div className="text-sm-end">
                  Работаем с <img src={paymentSystems} height={22} alt="" />
                </div>
              </Col>
            </Row>
          </Container>
        </footer>
      </React.Fragment>
    );
  }
}

export default Footer;
